export enum TaskTypeEnum {
	MajorBet = 1,
	MinorBet = 2,
	ClickVirtualSports = 3,
	ClickSabaFeatures = 4
}

export enum ClickTaskTypeEnum {
	// task type = 3
	SabaSoccerVirtual = 1,
	SabaSoccerPinGoal = 2,
	SabaSoccerMarble = 3,
	VirtualSports = 4,
	CasinoRoyale = 5,
	NumberGame = 6,
	Happy5 = 7,
	RngKeno = 8,
	Lottery = 9,
	Vgaming = 10,
	// task type = 4
	StreamerIcon = 11,
	StreamingIcon = 12,
	LiveMatchIcon = 13,
	SmpIcon = 14,
	SabaTimeMachine = 15,
	BBPlus = 17,
	ParlayButton = 18
}

export interface WcPromotionSpinDailyInfoPoints {
	totalPoints: number;
	usedPoints: number;
	remainingPoints: number;
}

export interface WcPromotionSpinDailyTaskBase {
	taskId: number;
	pointsPerCompletion: number;
	isCompleted: boolean;
	completedTime?: Date;
}

/** taskType 1、2：betType */
export interface WcPromotionSpinDailyBetTask extends WcPromotionSpinDailyTaskBase {
	taskType: TaskTypeEnum.MajorBet | TaskTypeEnum.MinorBet;
	betType: number;
}

/** taskType 3、4：clickTaskType */
export interface WcPromotionSpinDailyClickTask extends WcPromotionSpinDailyTaskBase {
	taskType: TaskTypeEnum.ClickVirtualSports | TaskTypeEnum.ClickSabaFeatures;
	clickTaskType: number;
}

export type WcPromotionSpinDailyTask =
	| WcPromotionSpinDailyBetTask
	| WcPromotionSpinDailyClickTask;

export interface WcPromotionSpinDailyInfoCycle {
	cycleDate: string;
	points?: WcPromotionSpinDailyInfoPoints;
	tasks: WcPromotionSpinDailyTask[];
}

/** GET /spin/dailyInfo → Data 為多筆週期 */
export type WcPromotionSpinDailyInfoResponse = WcPromotionSpinDailyInfoCycle[];

export type WcMissionPayload = {
	taskType: TaskTypeEnum;
	sportType?: number;
	productCode?: string;
	betTypes?: Array<number>;
	transId?: string;
};

/* for API from /spin/tasks/complete */
export type WcSpinCompletedTask = {
	taskType: TaskTypeEnum;
	betType?: number;
	clickTaskType?: ClickTaskTypeEnum;
	transId?: string;
}; 

export interface WcPromotionSpinTasksCompleteResponse {
	completedTasks: Array<WcSpinCompletedTask>;
	shouldNotify: boolean;
}